import { render, staticRenderFns } from "./EmployeeCardInfo.vue?vue&type=template&id=22a7bda4&"
import script from "./EmployeeCardInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports